<template>
	<div class="content-button">
		<div :class="`button-text ${isPost || !isDelete ? 'button-unactive':'button-active'} `" @click="$emit('post-gl')">
			<v-icon v-if="$vuetify.breakpoint.mdAndUp && !postLoading" small color="white" class="mr-1">mdi-check</v-icon>
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && postLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#FFFFFF`" indeterminate></v-progress-circular>			
			Post
		</div>
		<div :class="`ml-2 button-text ${isActive ? 'button-default-able':'button-default'}`" @click="$emit('more-info')">
			<v-icon v-if="$vuetify.breakpoint.mdAndUp && !rejectLoading" small :color="isActive ? '#00AAFD':'rgba(25, 42, 62, 0.15)'" class="mr-1">mdi-close</v-icon>
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && rejectLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>			
			<span>Reject</span>
		</div>
		<div :class="`ml-2 button-text ${ isActive ? 'button-grey-able':'button-default'}`" @click="$emit('forward')">
			<v-progress-circular v-if="$vuetify.breakpoint.mdAndUp && forwardLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#82899B`" indeterminate></v-progress-circular>
			<span>Forward</span>
		</div>
		<div v-if="claimId === 0 && $vuetify.breakpoint.mdAndUp" class="button-text button-grey-able ml-2" @click="$emit('print')">
			<v-progress-circular v-if="$vuetify.breakpoint.mdAndUp && printLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#82899B`" indeterminate></v-progress-circular>
			Print
		</div>
		<div v-if="$vuetify.breakpoint.mdAndUp" class="button-text ml-2" :class="isRecover ? 'button-grey-able':'button-default'" @click="$emit('recover')">
			<v-progress-circular v-if="$vuetify.breakpoint.mdAndUp && recoverLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#82899B`" indeterminate></v-progress-circular>
			Recover
		</div>
		<div v-if="$vuetify.breakpoint.mdAndUp" class="button-text ml-2" :class="isDelete ? 'button-grey-able button-delete-hover':'button-default'" @click="$emit('delete')">
			<v-progress-circular v-if="$vuetify.breakpoint.mdAndUp && deleteLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#82899B`" indeterminate></v-progress-circular>
			Delete
		</div>
	</div>
</template>
<script>
export default {
	name: 'FinanceButton',
	props: {
		isPost: {
			type: Boolean,
			default: false
		},
		isActive: {
			type: Boolean,
			default: false
		},
		isDelete: {
			type: Boolean,
			default: false
		},
		isRecover: {
			type: Boolean,
			default: false
		},
		postLoading: {
			type: Boolean,
			default: false
		},
		rejectLoading: {
			type: Boolean,
			default: false
		},
		forwardLoading: {
			type: Boolean,
			default: false
		},
		deleteLoading: {
			type: Boolean,
			default: false
		},
		printLoading: {
			type: Boolean,
			default: false
		},
		recoverLoading: {
			type: Boolean,
			default: false
		},
		claimId: {
			type: Number,
			default: 0
		}
	}
}
</script>
<style lang="scss" scoped>
.content-button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.button-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  padding: 0 12px;
  border-radius: 4px;
}
.button-active {
  background: #00AAFD;
  color: #FFFFFF;
  &:hover {
    cursor: pointer;
  }
}
.button-unactive {
  background: rgba(25, 42, 62, 0.15);
  color: #FFFFFF;
}
.button-default {
  border: 1px solid rgba(25, 42, 62, 0.15);
  color: rgba(25, 42, 62, 0.15);
}
.button-default-able {
  border: 1px solid #00AAFD;
  color: #00AAFD;
  &:hover {
    cursor: pointer;
  }
}
.button-grey-able {
	border: 1px solid #82899B;
  color: #82899B;
  &:hover {
    cursor: pointer;
  }
}
.button-delete-hover {
	&:hover {
    border: 1px solid #F45252;
  	color: #F45252;
  }
}
</style>